import { useQuery } from "@tanstack/react-query";

import { useTranslate } from "@similarweb/i18n-provider";
import Sentry from "@similarweb/sentry-logger";

import { useToasts } from "app/common/hooks";
import { apiClient, getQueryKey } from "app/modules/api-client";
import { getResponseErrorDetail, isResourceNotFoundError } from "app/services/fetchService";

import { ActivationComponentAssets } from "../../../../../helpers/ActivationAssets";

export const useAlertsSecondaryDomainsDetail = (activationSetId: string) => {
    const isSecondaryDomainsListEnabled = ActivationComponentAssets.alertsSecondaryListEnabled;

    const { translate } = useTranslate();
    const { showErrorToast } = useToasts();

    return useQuery({
        queryKey: getQueryKey({
            tag: "Alerts",
            methodName: "userdataActivationAlertsSecondaryDomainsDetail",
            args: [activationSetId],
        }),
        queryFn: async () => {
            try {
                const result = await apiClient.Alerts.userdataActivationAlertsSecondaryDomainsDetail(activationSetId);

                return result;
            } catch (error) {
                if (isResourceNotFoundError(error)) {
                    return null;
                }

                Sentry.errorTracker({
                    e: error,
                    message: "Failed to load Alerts.userdataActivationAlertsSecondaryDomainsDetail data",
                    level: "error",
                    params: {
                        extra: {
                            activationSetId,
                        },
                    },
                });

                showErrorToast(translate("common.api.error", { error: getResponseErrorDetail(error) }));
                throw error;
            }
        },
        enabled: isSecondaryDomainsListEnabled,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
};
